import { createInstance } from '@/utils/request'

const isPro = process.env.NODE_ENV === 'production'

const version = ({ version, appId }) => ({
  'x-app-id': appId,
  'x-version': version
})

const resumeBaseURL = 'https://recruitment-api.jin10.com'
const uploadBaseURL = 'https://oss-api.jin10.com'

// 招聘api
const resumeAxios = createInstance({
  baseURL: resumeBaseURL,
  headers: version({ version: isPro ? '1.0.0' : '0.1.0.0', appId: '7KSdAyWMMXNQS8hH' })
})

// 上传附件api
const uploadAxios = createInstance({
  baseURL: uploadBaseURL,
  headers: version({ version: '1.0', appId: '7KSdAyWMMXNQS8hH' })
})

export const http = {
  get: (url, params, config = {}) => resumeAxios({ method: 'GET', url, params, headers: { ...config }}),
  post: (url, data, config = {}) => resumeAxios({ method: 'POST', url, data, headers: { ...config }})
}

export const UploadHttp = {
  post: (url, data, config = {}) => uploadAxios({ method: 'POST', url, data, config })
}
